import { render } from "./CreateLocation.vue?vue&type=template&id=f4151df8&scoped=true"
import script from "./CreateLocation.vue?vue&type=script&lang=js"
export * from "./CreateLocation.vue?vue&type=script&lang=js"

import "./CreateLocation.vue?vue&type=style&index=0&id=f4151df8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4151df8"]])

export default __exports__